// import React, { useState, useEffect } from "react";
// import { useTranslation } from "react-i18next";
// import "./PackInfoTab.scss"; // Import your custom styles

// const PackInfoTab = ({ pack, companyId }) => {
//   const { t } = useTranslation();
//   const [timeLeft, setTimeLeft] = useState({ text: "", days: null });

//   useEffect(() => {
//     if (!companyId?.endDate) {
//       setTimeLeft({ text: t("profile.notAvailable"), days: null });
//       return;
//     }

//     const calculateTimeLeft = () => {
//       const now = new Date();
//       const endDate = new Date(companyId.endDate);
//       const diff = endDate - now;

//       if (diff <= 0) {
//         return { text: t("profile.expired"), days: 0 };
//       }

//       const days = Math.floor(diff / (1000 * 60 * 60 * 24));
//       const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
//       const minutes = Math.floor((diff / (1000 * 60)) % 60);
//       const seconds = Math.floor((diff / 1000) % 60);

//       return {
//         text: `${days}j ${hours}h ${minutes}m ${seconds}s`,
//         days,
//       };
//     };

//     const timer = setInterval(() => {
//       setTimeLeft(calculateTimeLeft());
//     }, 1000);

//     setTimeLeft(calculateTimeLeft());

//     return () => clearInterval(timer);
//   }, [pack, companyId?.endDate, t]);

//   return (
//     <>
//       <h5 className="border-bottom pb-2" style={{ color: "#0f84ff" }}>
//         {t("profile.packInfo")}
//       </h5>

//       {pack ? (
//         <div className="row">
//           <div className="col-sm-6 mb-3">
//             <small className="text-muted">{t("profile.packName")}</small>
//             <p className="text-dark">{pack.name}</p>
//           </div>

//           <div className="col-sm-6 mb-3">
//             <small className="text-muted">{t("profile.description")}</small>
//             <p className="text-dark">{pack.description}</p>
//           </div>

//           <div className="col-sm-6 mb-3">
//             <small className="text-muted">{t("profile.price")}</small>
//             <p className="text-dark">{pack.price} €</p>
//           </div>

//           <div className="col-sm-6 mb-3">
//             <small className="text-muted">{t("profile.duration")}</small>
//             <p className="text-dark">{pack.durationInDays} jours</p>
//           </div>

//           <div className="col-sm-6 mb-3">
//             <small className="text-muted">{t("profile.status")}</small>
//             <p className="text-dark">
//               {pack.isActive ? t("profile.active") : t("profile.inactive")}
//             </p>
//           </div>

//           <div className="col-sm-6 mb-3">
//             <small className="text-muted">{t("profile.timeLeft")}</small>
//             <p
//               className={`${
//                 timeLeft.days !== null && timeLeft.days < 3
//                   ? "urgent-time"
//                   : "text-dark"
//               }`}
//             >
//               {timeLeft.text || t("profile.notAvailable")}
//             </p>
//           </div>
//         </div>
//       ) : (
//         <p className="text-muted">{t("profile.notAvailable")}</p>
//       )}
//     </>
//   );
// };

// export default PackInfoTab;
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./PackInfoTab.scss"; // Import your custom styles

const PackInfoTab = ({ pack, companyId }) => {
  const { t } = useTranslation();
  const [timeLeft, setTimeLeft] = useState({ text: "", days: null });

  useEffect(() => {
    if (!companyId?.endDate) {
      setTimeLeft({ text: t("profile.notAvailable"), days: null });
      return;
    }

    const calculateTimeLeft = () => {
      const now = new Date();
      const endDate = new Date(companyId.endDate);
      const diff = endDate - now;

      if (diff <= 0) {
        return { text: t("profile.expired"), days: 0 };
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((diff / (1000 * 60)) % 60);
      const seconds = Math.floor((diff / 1000) % 60);

      return {
        text: `${days}j ${hours}h ${minutes}m ${seconds}s`,
        days,
      };
    };

    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    setTimeLeft(calculateTimeLeft());

    return () => clearInterval(timer);
  }, [pack, companyId?.endDate, t]);

  return (
    <>
      <h5 className="border-bottom pb-2" style={{ color: "#0f84ff" }}>
        {t("profile.packInfo")}
      </h5>

      {pack ? (
        <div className="row">
          <div className="col-sm-6 mb-3">
            <small className="text-muted">{t("profile.packName")}</small>
            <p className="text-dark">{pack.name}</p>
          </div>

          <div className="col-sm-6 mb-3">
            <small className="text-muted">{t("profile.description")}</small>
            <p className="text-dark">{pack.description}</p>
          </div>

          <div className="col-sm-6 mb-3">
            <small className="text-muted">{t("profile.price")}</small>
            <p className="text-dark">{pack.price} €</p>
          </div>

          <div className="col-sm-6 mb-3">
            <small className="text-muted">{t("profile.duration")}</small>
            <p className="text-dark">{pack.durationInDays} jours</p>
          </div>

          <div className="col-sm-6 mb-3">
            <small className="text-muted">{t("profile.status")}</small>
            <p className="text-dark">
              {pack.isActive ? t("profile.active") : t("profile.inactive")}
            </p>
          </div>

          <div className="col-sm-6 mb-3">
            <small className="text-muted">{t("profile.timeLeft")}</small>
            <p
              className={`${
                timeLeft.days !== null && timeLeft.days < 3
                  ? "urgent-time"
                  : "text-dark"
              }`}>
              {timeLeft.text || t("profile.notAvailable")}
            </p>
          </div>
        </div>
      ) : (
        <p className="text-muted">{t("profile.notAvailable")}</p>
      )}
    </>
  );
};

export default PackInfoTab;
